import { render, staticRenderFns } from "./LogoutConfirm.vue?vue&type=template&id=51ddb82c&"
import script from "./LogoutConfirm.vue?vue&type=script&lang=ts&"
export * from "./LogoutConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports